export default {
  props: {
    ordine: Object,
    icon: Boolean,
    loading: Boolean,
    conteggio_prop: {
      type: Object,
      default: null,
    },
    id_conteggio: {
      type: String,
      default: null,
    },
    id_ordine: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      conteggio: null,
      dialog: false,
      loading_invia: false,
      integrità: null,
      loading_conteggio: true,
      view: 0,
      tab: null,
      selected_cart: { id: 0, prodotti: [] },
    };
  },
  computed: {
    lista_combinata() {
      if (!this.conteggio) {
        return [];
      }
      let lista_comb = [];
      this.conteggio.prodotti.forEach((prodotto) => {
        if (this.ordine) {
          let art_ordine = this.ordine.articoli
            .filter((art) => !art.eliminato)
            .find((articolo) => articolo.art == prodotto.id_prodotto);
          if (art_ordine) {
            lista_comb.push({
              id_prodotto: prodotto.id_prodotto,
              qta_ordine: art_ordine.colori
                .map((col) => (col.qta_admin ? col.qta_admin : col.numero))
                .reduce((tot, sum) => tot + sum, 0),
              qta_contata: prodotto.qta,
              lotti: prodotto.lotti,
              prezzo_contato: prodotto.prezzo_contato,
              a_vaso: prodotto.a_vaso,
            });
          } else {
            lista_comb.push({
              id_prodotto: prodotto.id_prodotto,
              qta_contata: prodotto.qta,
              qta_ordine: 0,
              lotti: prodotto.lotti,
              prezzo_contato: prodotto.prezzo_contato,
              a_vaso: prodotto.a_vaso,
            });
          }
        } else {
          lista_comb.push({
            id_prodotto: prodotto.id_prodotto,
            qta_contata: prodotto.qta,
            qta_ordine: 0,
            lotti: prodotto.lotti,
            prezzo_contato: prodotto.prezzo_contato,
          });
        }
      });
      if (this.ordine) {
        this.ordine.articoli
          .filter((art) => !art.eliminato)
          .forEach((art) => {
            let art_contato = this.conteggio.prodotti.find(
              (element) => element.id_prodotto == art.art
            );
            if (!art_contato) {
              lista_comb.push({
                id_prodotto: art.art,
                qta_ordine: art.colori
                  .map((col) => (col.qta_admin ? col.qta_admin : col.numero))
                  .reduce((tot, sum) => tot + sum, 0),
                qta_contata: 0,
              });
            }
          });
      }
      return lista_comb;
    },
    cliente() {
      if (this.ordine) {
        return this.$store.getters.get_cliente_by_iva(this.ordine.iva);
      } else {
        return this.$store.getters.get_cliente_by_iva(this.conteggio.cliente);
      }
    },
    listino() {
      return this.cliente.listino;
    },
    carrelli_stesso_subconteggio() {
      if (!this.conteggio || !this.conteggio.carrelli) {
        return [];
      }

      const gruppi = {};

      this.conteggio.carrelli.forEach((carrello) => {
        const id_sub = carrello.id_subconteggio;

        if (!gruppi[id_sub]) {
          gruppi[id_sub] = {
            id_subconteggio: id_sub,
            carrelli: [],
          };
        }

        gruppi[id_sub].carrelli.push(carrello);
      });

      return Object.values(gruppi);
    },
    totale_contato() {
      return this.lista_combinata
        .map((prod) => {
          if (prod.prezzo_contato) {
            return (
              prod.qta_contata *
              (prod.a_vaso
                ? prod.prezzo_contato /
                  this.$store.getters.get_prodotto_by_id(prod.id_prodotto).unita
                : prod.prezzo_contato)
            );
          }
          let prodotto = this.$store.getters.get_prodotto_by_id(
            prod.id_prodotto
          );
          switch (this.listino) {
            case "1":
              return prod.qta_contata * prodotto.prezzo1;
            case "2":
              return prod.qta_contata * prodotto.prezzo2;
            case "3":
              return prod.qta_contata * prodotto.prezzo3;
          }
        })
        .reduce((tot, sum) => tot + sum, 0);
    },
    tot_iva_contato() {
      return this.lista_combinata
        .map((prod) => {
          if (prod.prezzo_contato) {
            let prodotto = this.$store.getters.get_prodotto_by_id(
              prod.id_prodotto
            );
            return (
              prod.qta_contata *
              (prod.a_vaso
                ? prod.prezzo_contato /
                  this.$store.getters.get_prodotto_by_id(prod.id_prodotto).unita
                : prod.prezzo_contato) *
              (prodotto.iva / 100)
            );
          }
        })
        .reduce((tot, sum) => tot + sum, 0);
    },
    tot_trasporto() {
      if(!this.conteggio.trasporto){
        return 0;
      }
      let trasporto = this.$store.getters.get_trasporto;
      let prezzo_trasporto = 0;
      switch (this.cliente.listino) {
        case "1":
          prezzo_trasporto = trasporto.prezzo_listino_1;
          break;
        case "2":
          prezzo_trasporto = trasporto.prezzo_listino_2;
          break;
        case "3":
          prezzo_trasporto = trasporto.prezzo_listino_3;
          break;
      }
      if (this.totale_contato > trasporto.soglia) {
        return 0;
      } else {
        return prezzo_trasporto;
      }
    },
    tot_iva_trasporto() {
      return this.tot_trasporto * 0.1;
    },
    tot_iva_documento() {
      return this.tot_iva_contato;
    },
    totale_ordinato() {
      return this.lista_combinata
        .map((prod) => {
          let qta = 0;
          if (prod.qta_ordine) {
            qta = prod.qta_ordine;
          }
          if (prod.prezzo_contato) {
            return prod.prezzo_contato * qta;
          }
          let prodotto = this.$store.getters.get_prodotto_by_id(
            prod.id_prodotto
          );
          switch (this.listino) {
            case "1":
              return qta * prodotto.prezzo1;
            case "2":
              return qta * prodotto.prezzo2;
            case "3":
              return qta * prodotto.prezzo3;
          }
        })
        .reduce((tot, sum) => tot + sum, 0);
    },
    totale_discrepanza() {
      let differenza = this.totale_contato - this.totale_ordinato;
      return {
        tot: differenza,
        icon: !differenza ? "mdi-check" : "mdi-alert",
        color: !differenza ? "green" : "amber",
      };
    },
    totale_documento() {
      return this.totale_contato + (this.ordine ? this.ordine.tot_trasp : 0);
    },
    creatore(){
      return this.$store.getters.get_cliente_by_iva(this.conteggio.creato_da)?.nome || 'Utente non trovato';
    }
  },
  watch: {
    conteggio: function () {
      if (this.conteggio.cliente != null) {
        this.$store
          .dispatch("fetch_integrità", this.conteggio.cliente)
          .then((res) => {
            this.integrità = res;
          });
      }
    },
  },
  methods: {
    open() {
      this.dialog = true;
      if (this.ordine) {
        this.loading_conteggio = true;
        this.$store
          .dispatch("fetch_conteggio_by_id_ordine", this.ordine._id.$oid)
          .then((res) => {
            this.conteggio = res.data;
            if (
              this.conteggio.tipo == 1 &&
              this.conteggio.carrelli.length > 0
            ) {
              this.selected_cart.id = this.conteggio.carrelli[0].id_carrello;
              this.selected_cart.prodotti = this.conteggio.carrelli[0].prodotti;
            }
            this.loading_conteggio = false;
          });
      } else if (this.id_conteggio) {
        this.loading_conteggio = true;
        this.$store
          .dispatch("fetch_conteggio_by_id", this.id_conteggio)
          .then((res) => {
            this.conteggio = res.data;
            if (
              this.conteggio.tipo == 1 &&
              this.conteggio.carrelli.length > 0
            ) {
              this.selected_cart.id = this.conteggio.carrelli[0].id_carrello;
              this.selected_cart.prodotti = this.conteggio.carrelli[0].prodotti;
            }
            this.loading_conteggio = false;
          });
      } else {
        this.conteggio = this.conteggio_prop;
        if (this.conteggio.tipo == 1 && this.conteggio.carrelli.length > 0) {
          this.selected_cart.id = 0;
          this.selected_cart.prodotti = this.conteggio.carrelli[0].prodotti;
        }
        this.loading_conteggio = false;
      }
    },
    spedisci_conteggio() {
      this.loading_invia = true;
      this.$store.dispatch("invia_csv", this.conteggio.id).finally(() => {
        this.loading_invia = false;
      });
    },
    crea_contabile() {
      this.$refs.nuova_contabile.open();
    },
    put_product({ carrello, id_carrello }) {
      this.selected_cart.id = id_carrello;
      this.selected_cart.prodotti = carrello.prodotti;
    },
  },
};
